/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css, cx } from "@panda/css";

import { CosmosVariableRichText, CosmosText, hasContent, CosmosTextVariantEnum, CosmosRichText } from "../..";
import { CSSProperties } from "react";

export interface CosmosTitleProps {
	title?: CosmosVariableRichText | null;
	className?: string;
	style?: CSSProperties;
}

export const CosmosTitle = ({ title, className, style }: CosmosTitleProps): React.JSX.Element | null => {
	if (!title || (!title.text && !title.html)) {
		return null;
	}

	// Check if title has actual content (not just empty HTML tags or whitespace)
	if (!hasContent(title)) {
		return null;
	}

	let titleEl = null;

	if (title?.html && title?.html.includes("</")) {
		// Only render HTML if it has content (already checked by hasContent above)
		//remove any leading line breaks
		const cleanHtml = title.html.replace(/^<br \/>/, "").replace(/^<br\/>/, "");
		titleEl = (
			<CosmosRichText
				{...title}
				variant={title?.variant || CosmosTextVariantEnum.heading2XL}
				color={title?.color || "eds.text.primary"}
				html={cleanHtml}
				className={cx(
					className,
					css({
						"&& p": {
							marginBlock: "0",
						},
						"&& em": {
							fontStyle: "italic",
							paddingInlineEnd: "eds.dimension.6",
						},
					}),
				)}
				style={style}
			/>
		);
	} else if (title?.text && title.text.trim().length > 0) {
		titleEl = (
			<CosmosText
				variant={title?.variant || CosmosTextVariantEnum.heading2XL}
				color={title?.color || "eds.text.primary"}
				as={title?.as || undefined}
				className={className}
				style={style}
			>
				{title?.text}
			</CosmosText>
		);
	}

	return titleEl;
};
